import { render } from "./CatalogoIconos.vue?vue&type=template&id=14c9a386&scoped=true"
import script from "./CatalogoIconos.vue?vue&type=script&lang=js"
export * from "./CatalogoIconos.vue?vue&type=script&lang=js"

import "./CatalogoIconos.vue?vue&type=style&index=0&id=14c9a386&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-14c9a386"]])

export default __exports__